export default async ():Promise<string> =>  {
  const { $auth0 } = useNuxtApp()
  let getTokenSilently
  try {
    getTokenSilently = await $auth0.getTokenSilently()
  } catch (error) {
    throw new Error('Error getting token')
  }
  return `Bearer ${getTokenSilently}`
}